import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '@merchant-portal/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SafeUrlService {
  private readonly trustedDomains = environment.trustedImageDomains;
  private readonly allowedProtocols = ['https:'];
  private sanitizer = inject(DomSanitizer);

  sanitizeUrl(url: string | undefined | null, fallbackUrl?: string): SafeUrl {
    if (!url) {
      return this.sanitizer.bypassSecurityTrustUrl(fallbackUrl || '');
    }

    if (this.isUrlTrusted(url)) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    console.warn(`[SafeUrlService] Blocked untrusted URL: ${url}`);
    return this.sanitizer.bypassSecurityTrustUrl(fallbackUrl || '');
  }

  private isUrlTrusted(url: string): boolean {
    if (!url) {
      return false;
    }

    try {
      const urlObj = new URL(url);

      if (!this.allowedProtocols.includes(urlObj.protocol)) {
        return false;
      }

      return this.trustedDomains.some(
        domain => urlObj.hostname === domain || urlObj.hostname.endsWith(`.${domain}`)
      );
    } catch (error) {
      console.warn(`[SafeUrlService] Invalid URL format: ${url}`, error);
      return false;
    }
  }
}
